<template>
  <page-list
    :list="list"
    :columns="changedColumns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :showSearchbox="showSearchbox"
    :showGroupActions="showGroupActions"
    :export-data-options="exportDataOptions">
    <!-- <template v-slot:group-actions-append>
      <date-time
        class="ml-2"
        :getParams.sync="dateParam"
        :hasDefaultTime="false"
        @refresh="fetchData" />
    </template> -->
  </page-list>
</template>

<script>
import * as R from 'ramda'
import { mapGetters } from 'vuex'
import currencyRequest from '@Bill/mixins/currencyRequest'
import { getAmountColumns } from '@Bill/utils'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import ColumnsMixin from '../mixins/columns'
// import DateTime from '@Bill/sections/DateTime'

export default {
  name: 'CloudDomainList',
  components: {
    // DateTime,
  },
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, currencyRequest],
  props: {
    id: String,
    getParams: {
      type: Object,
      default: () => ({}),
    },
    cloudEnv: String,
    isAllowCreate: {
      type: Boolean,
      default: true,
    },
    hiddenActions: {
      type: Array,
      default: () => ([]),
    },
    billShared: Boolean,
    projectShared: Boolean,
  },
  data () {
    return {
      batchDeleteBill: true,
      dateParam: {},
      list: this.$list.createList(this, {
        id: this.id,
        apiVersion: 'v1',
        idKey: 'month',
        exportUseIdKey: true,
        resource: 'billsanalysises',
        getParams: this.getParam,
        // filterOptions: {
        //   id: {
        //     label: this.$t('table.title.id'),
        //     filter: true,
        //     formatter: val => {
        //       return `domain_id.equals('${val}')`
        //     },
        //   },
        //   name: {
        //     label: this.$t('table.title.name'),
        //     filter: true,
        //     formatter: val => {
        //       return `domain.contains('${val}')`
        //     },
        //   },
        // },
      }),
    }
  },
  computed: {
    ...mapGetters(['isAdminMode']),
    changedColumns () {
      const columns = R.clone(this.columns)
      const amountColumns = getAmountColumns({
        disable_cost_conversion: this.currencyParams.disable_cost_conversion,
        dateModeTitle: this.$t('bill.text_308'),
        currencySign: this.currencySign,
      })
      return [...columns, ...amountColumns]
    },
    exportDataOptions () {
      const items = this.changedColumns.map(item => {
        return {
          key: item.field,
          label: item.title,
        }
      })
      return { items }
    },
  },
  watch: {
    currencyParams: {
      handler: function () {
        this.fetchData()
      },
      deep: true,
    },
    billShared () {
      this.fetchData()
    },
    projectShared () {
      this.fetchData()
    },
  },
  created () {
    this.initSidePageTab('overview')
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.list.fetchData()
    },
    getParam () {
      const ret = {
        query_type: 'month',
        // start_date: this.$moment().startOf('month').format('YYYY-MM-DD') + 'TZ',
        // end_date: this.$moment().endOf('month').format('YYYY-MM-DD') + 'TZ',
        ...this.currencyParams,
        ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams),
        details: false,
        order_by: 'month',
        order: 'desc',
        // ...this.dateParam,
      }
      if (this.billShared) {
        ret.is_prepaid_amortizing = true
      } else {
        ret.is_prepaid_amortizing = false
      }
      if (this.projectShared) {
        ret.is_project_sharing = true
      } else {
        ret.is_project_sharing = false
      }
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'BillTimeSidePage', {
        id: row.month,
        resource: () => {
          return {
            data: Object.assign({}, row, { name: this.monthFormatter(row.month) }),
          }
        },
      }, {
        list: this.list,
        hiddenActions: this.hiddenActions,
      })
    },
  },
}
</script>
